import React from 'react'
import { Box, Text } from '@chakra-ui/react'
import { getShortName } from '../../../utils/common.util'
import { useAuthContext } from '../../../context/auth.context'
import { getLeaveTimeDate, getDayname } from '../../../utils/date.utils'
import { useLanguageContext } from '../../../context/locale.context'
import SVGIcon from '../../../assets/svgIcons'
const Requestgreeting = ({ reqText, greetingText, height }) => {
	const {
		state: { authData },
	} = useAuthContext()
	const {
		state: { locale },
	} = useLanguageContext()
	return (
		<Box
			bg='brand.700'
			borderRadius={'0px 12px 12px 12px'}
			w='55%'
			p='5'
			h={height}
			color={'#FFFFFF'}
			fontSize={'12px'}
			fontWeight='500'
			mb='5'
			mt='5'
		>
			<Box display={'flex'} flexDirection='row'>
				<SVGIcon
					iconName='GreneSmallLogoSvg'
					svgProps={{ width: '36', height: '10', viewBox: '0 0 36 10' }}
					pathProps={{ fill: 'white' }}
				/>
				<Text
					fontSize={'14px'}
					fontWeight='500'
					fontStyle={'normal'}
					ml='5'
					mt='-1'
				>
					Hi{' '}
					{!!getShortName(authData?.operating_asset_first_name)
						? getShortName(authData?.operating_asset_first_name).split(' ')[0]
						: getShortName(authData?.operating_asset_first_name)}
				</Text>
			</Box>
			<Text mt='2'> {greetingText}</Text>

			<Text>{reqText}</Text>
			<Text color={'#E1E1E1'} fontSize='10px' mt='3'>
				{getDayname(new Date())} {getLeaveTimeDate().replace(',', '   |')}
			</Text>
		</Box>
	)
}
export default Requestgreeting
